import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { datadogLogs } from '@datadog/browser-logs';

const FeatureContext = createContext({ loaded: false, flags: {} });

// Cliente próprio, SEM o interceptor global do services/api: a checagem de flags
// roda na abertura do sistema, em qualquer tela, e não pode mostrar toast de erro
// nem derrubar a sessão (401). Sessão expirada é tratada pela próxima chamada real.
const featureApi = axios.create({ baseURL: process.env.REACT_APP_API_URL });

// A API é a fonte da verdade das feature flags: ligar ou desligar não exige
// rebuild do front. Na falha, tudo fica desligado (o sistema de sempre), com o
// motivo no console para quem investigar.
export function FeatureProvider({ children }) {
  const [state, setState] = useState({ loaded: false, flags: {} });

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      setState({ loaded: true, flags: {} });
      return;
    }

    featureApi
      .get('scheduling/features', { headers: { Authorization: token } })
      .then(response => setState({ loaded: true, flags: response.data || {} }))
      .catch(err => {
        datadogLogs.logger.warn(
          '[features] could not load feature flags — all features off',
          undefined,
          err,
        );
        setState({ loaded: true, flags: {} });
      });
  }, []);

  return (
    <FeatureContext.Provider value={state}>{children}</FeatureContext.Provider>
  );
}

export function useFeature(name) {
  const { loaded, flags } = useContext(FeatureContext);

  return { loaded, enabled: flags[name] === true };
}
